var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: "12" } },
        [
          [
            !_vm.customersList.length ||
            Object.keys(_vm.$route?.query).length === 0
              ? _c("v-empty-state", {
                  staticClass: "mt-10",
                  attrs: {
                    type: "customer",
                    id: "clientes",
                    height: 320,
                    description: `y realizar búsquedas por ${_vm.$t(
                      "generals.RUT"
                    )}`,
                    title: "Podrás crear nuevos clientes",
                    hiddenDescription: false,
                    isFree: true,
                  },
                })
              : [
                  _c("v-data-table", {
                    class: {
                      "fixed-table":
                        _vm.$store.state.base.isExpandNavigationDrawer,
                    },
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.customersList,
                      "items-per-page": _vm.pagination,
                      "mobile-breakpoint": "",
                      "hide-default-header": "",
                      "disable-sort": "",
                      "hide-default-footer": "",
                      "fixed-header": "",
                      height: _vm.heightTable,
                    },
                    on: {
                      "click:row": (customersList) => {
                        _vm.goTo(customersList.id)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `header`,
                          fn: function ({ props: { headers } }) {
                            return [
                              _c("VTableHeaders", {
                                attrs: { headers: headers },
                                on: { sort: _vm.setSort },
                              }),
                              _c("v-divider", {
                                staticStyle: {
                                  position: "absolute",
                                  "z-index": "2",
                                  "margin-top": "-6px",
                                  "min-width": "100%",
                                  "margin-left": "-5px",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: `item.name`,
                          fn: function ({ item }) {
                            return [
                              (item || {}).name
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "body-2 d-inline-block text-truncate",
                                      staticStyle: { "max-width": "100%" },
                                    },
                                    [_vm._v(_vm._s((item || {}).name))]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block body-2 mb-1 text--disabled font-italic",
                                    },
                                    [_vm._v("Sin especificar")]
                                  ),
                              ((item || {}).taxpayer || {}).tax_id
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "caption grey-300--text d-block",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("generals.RUT")) +
                                          " " +
                                          _vm._s(
                                            ((item || {}).taxpayer || {}).tax_id
                                          )
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block body-2 text--disabled font-italic",
                                    },
                                    [_vm._v("Sin especificar")]
                                  ),
                            ]
                          },
                        },
                        {
                          key: `item.business_activity`,
                          fn: function ({ item }) {
                            return [
                              item.business_activity
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "body-2 d-inline-block text-truncate",
                                      staticStyle: { "max-width": "100%" },
                                    },
                                    [_vm._v(_vm._s(item.business_activity))]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block body-2 text--disabled font-italic",
                                    },
                                    [_vm._v("Sin especificar")]
                                  ),
                            ]
                          },
                        },
                        {
                          key: `item.email`,
                          fn: function ({ item }) {
                            return [
                              item.email
                                ? _c("span", [_vm._v(_vm._s(item.email))])
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block body-2 text--disabled font-italic",
                                    },
                                    [_vm._v("Sin especificar")]
                                  ),
                            ]
                          },
                        },
                        {
                          key: `item.address`,
                          fn: function ({ item }) {
                            return [
                              item.address
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "body-2 d-inline-block text-truncate",
                                      staticStyle: { "max-width": "100%" },
                                    },
                                    [_vm._v(_vm._s(item.address))]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block body-2 text--disabled font-italic",
                                    },
                                    [_vm._v("Sin especificar")]
                                  ),
                            ]
                          },
                        },
                        {
                          key: `item.state`,
                          fn: function ({ item }) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.nameState(item.state) || item.state
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm.showPagination || _vm.showAll
                    ? _c("VMainPagination", { attrs: { count: _vm.count } })
                    : _vm._e(),
                ],
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }